import React from 'react';

const OfferDetails = () => {
	return (
		<>
			By enrolling today, you are authorizing us to charge you (4) equal
			installments of $25 to your debit/credit card ($100 total) for your
			year-long service. The first installment payment will occur when you
			complete your order form online, with the remaining three (3) installment
			payments billed within the twelve (12) month period during which you can
			access the website and use the Service.
		</>
	);
};

export default OfferDetails;
